import { useEffect, useMemo } from 'react'
import _ from 'lodash'

const useThrottledOnScroll = (callback, delay) => {
  const throttledCallback = useMemo(
    () => (callback ? _.throttle(callback, delay) : noop),
    [callback, delay]
  )

  useEffect(() => {
    if (throttledCallback === noop) {
      return undefined
    }
    const scrollSpy = document.getElementById('scrollspy')
    scrollSpy.addEventListener('scroll', throttledCallback)
    return () => {
      scrollSpy.removeEventListener('scroll', throttledCallback)
      throttledCallback.cancel()
    }
  }, [throttledCallback])
}

const noop = () => { }

export default useThrottledOnScroll